// What the header, footer, logos and product page show before the site content has loaded, or if it can't be
// reached. These are the original built-in values (the same ones the dashboard starts from), so the site never
// looks different while loading. Stores and the static pages are only shown once loaded.
// Generated from backend/app/services/site_content.py — keep in step with it.
export const FALLBACK_SITE = {
  "features": {
    "blog": false,
    "faqs": false
  },
  "vars": {
    "email": "support@rayoptics.in",
    "phone": "+91 94904 24422",
    "phone_tel": "+919490424422",
    "address": "Padmapriya Complex, Bhanugudi Junction, Kakinada",
    "hours": "Mon – Sat: 9:30 AM – 9:30 PM\nSun: 5:00 PM – 9:00 PM",
    "site_name": "Rayoptics",
    "free_shipping_threshold": "499",
    "shipping_fee": "49",
    "legal_name": "Rayoptics",
    "gstin": ""
  },
  "settings": {
    "store_name": "Rayoptics",
    "tagline": "",
    "instagram": "",
    "facebook": "",
    "pinterest": "",
    "youtube": "",
    "whatsapp": "",
    "linkedin": ""
  },
  "branding": {
    "logo_mark": "/RayOpticsLogo.png",
    "logo_text": "/RayOpticsTextLogo.png",
    "footer_logo_mark": "/RayOpticsLogo-cropped.png",
    "footer_logo_text": "/RayOpticsTextLogo-cropped.png",
    "favicon": "/favicon.png"
  },
  "header": {
    "nav": [
      {
        "label": "Eyeglasses",
        "href": "",
        "children": [
          {
            "label": "Men",
            "href": "/shop?category=eyeglasses&gender=men"
          },
          {
            "label": "Women",
            "href": "/shop?category=eyeglasses&gender=women"
          },
          {
            "label": "Kids",
            "href": "/shop?category=eyeglasses&gender=kids"
          },
          {
            "label": "Unisex",
            "href": "/shop?category=eyeglasses&gender=unisex"
          }
        ]
      },
      {
        "label": "Computer / Blue-Cut Specs",
        "href": "/shop?category=computer-glasses",
        "children": []
      },
      {
        "label": "Reading Glasses",
        "href": "/shop?category=reading-glasses",
        "children": []
      },
      {
        "label": "Frame Types",
        "href": "",
        "children": [
          {
            "label": "Rimless",
            "href": "/shop?sub_category=rimless"
          },
          {
            "label": "Supra/Half-Rim",
            "href": "/shop?sub_category=half-rim"
          },
          {
            "label": "Full-Rim",
            "href": "/shop?sub_category=full-rim"
          }
        ]
      },
      {
        "label": "Upload Prescription",
        "href": "/upload-prescription",
        "children": []
      },
      {
        "label": "Visit Kakinada Store / Book Eye Test",
        "href": "/stores/kakinada",
        "children": []
      }
    ],
    "trending_searches": [
      "Transparent Frames",
      "Aviators",
      "Blue Light Glasses",
      "Ray-Ban"
    ],
    "search_placeholder": "Search for frames, lenses, or shapes...",
    "topbar_link": {
      "label": "Contact Us",
      "href": "/contact"
    }
  },
  "footer": {
    "tagline": "Premium eyewear at budget-friendly prices. See the world in style — without breaking the bank.",
    "columns": [
      {
        "title": "Shop",
        "links": [
          {
            "label": "Eyeglasses",
            "href": "/shop?category=eyeglasses"
          },
          {
            "label": "Sunglasses",
            "href": "/shop?category=sunglasses"
          },
          {
            "label": "Contact Lenses",
            "href": "/shop?category=contact-lenses"
          },
          {
            "label": "Reading Glasses",
            "href": "/shop?category=reading-glasses"
          },
          {
            "label": "Kids Glasses",
            "href": "/shop?gender=kids"
          },
          {
            "label": "New Arrivals",
            "href": "/shop?sort=newest"
          }
        ]
      },
      {
        "title": "Company",
        "links": [
          {
            "label": "About Us",
            "href": "/about"
          },
          {
            "label": "Our Stores",
            "href": "/stores"
          },
          {
            "label": "Blog",
            "href": "/blog"
          }
        ]
      },
      {
        "title": "Support",
        "links": [
          {
            "label": "Help Center",
            "href": "/help"
          },
          {
            "label": "FAQs",
            "href": "/faqs"
          },
          {
            "label": "Track Order",
            "href": "/account/orders"
          },
          {
            "label": "Return Policy",
            "href": "/returns"
          },
          {
            "label": "Privacy Policy",
            "href": "/privacy"
          },
          {
            "label": "Terms of Service",
            "href": "/terms"
          }
        ]
      }
    ],
    "socials": [
      "instagram",
      "facebook",
      "pinterest",
      "youtube",
      "linkedin"
    ],
    "newsletter": {
      "title": "Get Exclusive Deals First",
      "text": "Join 10,000+ subscribers. New arrivals & offers straight to your inbox. Unsubscribe anytime.",
      "placeholder": "Enter your email address",
      "button": "Subscribe Free"
    },
    "copyright": "© 2026 Rayoptics. All rights reserved.",
    "badges": [
      {
        "icon": "shield",
        "text": "SSL Secured"
      },
      {
        "icon": "card",
        "text": "Cashfree · UPI · Cards"
      }
    ]
  },
  "product_page": {
    "show_lens_types": false,
    "show_prescription": false,
    "lens_types": [
      {
        "value": "single_vision",
        "label": "Single Vision",
        "desc": "Standard prescription",
        "price": 0.0
      },
      {
        "value": "blue_cut",
        "label": "Blue Cut",
        "desc": "Blue light protection",
        "price": 200.0
      },
      {
        "value": "photochromic",
        "label": "Photochromic",
        "desc": "Darkens in sunlight",
        "price": 500.0
      },
      {
        "value": "anti_glare",
        "label": "Anti-Glare",
        "desc": "Reduces glare",
        "price": 150.0
      },
      {
        "value": "bifocal",
        "label": "Bifocal",
        "desc": "Near & far vision",
        "price": 400.0
      }
    ],
    "trust_badges": [
      {
        "icon": "truck",
        "text": "Free delivery above ₹{{free_shipping_threshold}}"
      },
      {
        "icon": "rotate",
        "text": "7-day easy returns"
      },
      {
        "icon": "shield",
        "text": "1-year warranty"
      },
      {
        "icon": "check",
        "text": "BIS certified lenses"
      }
    ]
  },
  "not_found": {
    "emoji": "👓",
    "code": "404",
    "title": "Page Not Found",
    "text": "Looks like you've wandered off the path. The page you're looking for doesn't exist or has been moved.",
    "primary": {
      "label": "Go Home",
      "href": "/"
    },
    "secondary": {
      "label": "Shop Frames",
      "href": "/shop"
    }
  },
  "auth_page": {
    "badge_type": "sparkles",
    "badge_emoji": "",
    "title": "Welcome to Rayoptics",
    "subtitle": "Premium eyewear at prices everyone loves. Your perfect frames are waiting.",
    "register_title": "",
    "register_subtitle": "",
    "stats": [
      { "number": "500+", "label": "Styles" },
      { "number": "50K+", "label": "Customers" },
      { "number": "₹299", "label": "Starting" }
    ]
  },
  "shop_page": {
    "title": "All Eyewear",
    "subtitle": "Explore our curated collection of eyeglasses, sunglasses & contact lenses.",
    "banner_image": "",
    "products_per_page": 12,
    "default_sort": "newest",
    "show_price_filter": true
  },
  "cart_page": {
    "empty_title": "Your cart is empty",
    "empty_subtitle": "Looks like you haven't added any frames yet!",
    "empty_button_text": "Start Shopping",
    "order_summary_title": "Order Summary",
    "coupon_placeholder": "Enter coupon code",
    "coupon_button_text": "Apply",
    "tax_note": "Inclusive of all taxes (GST)",
    "checkout_button_text": "Proceed to Checkout",
    "continue_shopping_text": "Continue Shopping",
    "trust_note": "100% Genuine Eyewear · Easy Returns · Fast Shipping"
  },
  "checkout_page": {
    "enable_prescription": false,
    "step1_title": "Select Delivery Address",
    "step2_title": "Review Your Order",
    "step3_title": "Complete Your Payment",
    "step3_subtitle": "Please complete your payment below to confirm your order.",
    "prescription_title": "Prescription (Optional)",
    "prescription_hint": "Skip if you chose lens type at product page.",
    "pay_button_text": "Pay with Cashfree",
    "security_badge_text": "Secure payment via Cashfree. You'll be redirected to complete payment.",
    "trust_points": [
      { "text": "Free returns within 7 days" },
      { "text": "1-year frame warranty" },
      { "text": "Secure Cashfree checkout" }
    ]
  },
  "shipping": {
    "free_threshold": 499.0,
    "fee": 49.0
  }
}
